/* esm.sh - date-fns@4.1.0/getMilliseconds */
import{toDate as e}from"./toDate.mjs";function o(t){return e(t).getMilliseconds()}var r=o;export{r as default,o as getMilliseconds};
//# sourceMappingURL=getMilliseconds.mjs.map